// extracted by mini-css-extract-plugin
export default {"smallMarginY":"AT6BNikgEe4MNyCIMma_","mediumMarginY":"M4W1Ud91nHOJkX1XPGdR","largeMarginY":"_JnnwBpFlhUSy0nJHbsA"};